<template>
    <div>
        <card-header title="Session Participants" icon="fa-users"></card-header>

        <card-toolbar>
            <button @click="exportParticipants()"><i class="far fa-file-excel"></i>Export</button>
        </card-toolbar>

        <card-body>
            <card-list>
                <subheader-list-item title="Participants" icon="fa-users"/>
                <session-participant-tile
                    :participant="participant"
                    :max-log-minutes="maxLogMinutes"
                    v-for="participant in participants"
                    :key="participant.registration_id"
                />
            </card-list>
            <infinite-loading @infinite="loadParticipants">
                <div slot="no-more"></div>
                <div slot="no-results">No Participants Found</div>
            </infinite-loading>
        </card-body>

        <card-footer>
            Showing <strong>{{ participants.length | numeral('0,0') }}</strong> of <strong>{{ total | numeral('0,0') }}</strong> Participants
        </card-footer>
    </div>
</template>

<script>
    import CardHeader from "@/TIER/components/CardHeader";
    import CardToolbar from "@/TIER/components/CardToolbar";
    import CardBody from "@/TIER/components/CardBody";
    import CardList from "@/TIER/components/CardList";
    import SubheaderListItem from "@/TIER/components/SubheaderListItem";
    import CardFooter from "@/TIER/components/CardFooter";
    import SessionParticipantTile from "@/components/tiles/SessionParticipantTile";

    import {client as http, apiUrl} from "@/http_client";

    export default {
        props: ['card', 'child', 'props'],
        components: {SessionParticipantTile, CardFooter, CardHeader, CardToolbar, CardBody, CardList, SubheaderListItem},
        data() {
            return {
                participants: [],
                total: 0,
                maxLogMinutes: 0,
                apiUrl: apiUrl,
            };
        },
        methods: {
            loadParticipants: function($state) {
                this.$emit('loading', true);
                http.get(`conferences/${this.props.confId}/sessions/${this.props.sessionId}/participants`, { force: true }).then(response => {
                    this.participants = response.data.participants;
                    this.total = response.data.total;
                    this.maxLogMinutes = response.data.maxLogMinutes;

                    this.$emit('loading', false);
                    if ($state) $state.loaded();
                    if ($state) $state.complete();
                });
            },
            exportParticipants: function() {
                http.get(`${this.apiUrl}conferences/${this.props.confId}/sessions/${this.props.sessionId}/participants/export`).then(response => {
                    const url = window.URL.createObjectURL(new Blob([response.data]));
                    const link = document.createElement('a');
                    link.href = url;
                    link.setAttribute('download', 'session-participants.csv');
                    document.body.appendChild(link);
                    link.click();
                }).catch(error => {
                    if (error.response && error.response.status === 404) {
                        window.alert('No participants to export');
                    } else {
                        window.alert('Error exporting participants');
                    }
                });
            },
            reload: function() {
                this.participants = [];
                this.total = 0;
                this.loadParticipants();
            }
        },
        mounted: function() {
            this.loadParticipants();
        }
    };
</script>
